import React from 'react';

const items = [
  { n: '01', t: '<2% convert on first visit', b: '98 out of every 100 hard-won visitors walk away. Your acquisition cost is being torched.' },
  { n: '02', t: '49% need 2–4 touchpoints', b: 'Half your buyers require multiple visits. Without retargeting, a rival closes them.' },
  { n: '03', t: 'CPM/CPC is negligence', b: 'Paying for impressions and clicks regardless of outcome is burning cash with no guarantee of return.' },
  { n: '04', t: 'Cookies killed easy wins', b: "Third-party cookies are gone. Brands relying on legacy retargeting stacks are flying blind." },
  { n: '05', t: 'One-size retargeting kills brand equity', b: 'Bombarding every visitor with the same ad drives ad fatigue, distrust, and churn.' },
];

export default function ProblemSection() {
  return (
    <section className="highlights-section" id="problem" data-testid="problem-section">
       <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360 ">
        <div className="highlights-kicker">
          <span />THE PROBLEM
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
            The <span className="accent">$260B</span><br />Bleeding Wound
          </h2>
          <div className="lg:col-span-5 reveal-on-scroll">
            <p className="sec-subhead leading-relaxed">
              Every day, $260 billion in potential revenue in the US and EU alone evaporates as shoppers browse, intend to buy, and disappear. Your CPM campaigns paid to bring them. Your competitors' campaigns will bring them back.
            </p>
            <div className="mt-4 border-l-4 border-[#ff5117] pl-6">
              <div className="font-display text-[36px] font-black leading-none">70%</div>
              <div className="text-[14px] font-bold tracking-wider">Global Cart Abandonment Rate</div>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 xl:grid-cols-5 mt-8 xl:mt-10 border-t border-l border-[#1a1a1a]">
          {items.map((it) => (
            <div
              key={it.n}
              className="p-5 border-r border-b border-[#1a1a1a] bg-white/70 shadow-md transition-colors"
            >
              <div className="text-[1.5rem] font-bold font-mono text-[#ff5117] mb-2 lg:mb-4">{it.n}</div>
              <div className="font-display font-bold text-[28px] lg:text-[24px] leading-tight mb-3">{it.t}</div>
              <p className="sec-subhead">{it.b}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
